import { RealEstate } from '../../generated/graphql';
import { AmountTable, AmountTableProps } from './Table';

export interface RealEstatePropertyTableContainerProps
  extends Pick<
    AmountTableProps,
    'title' | 'isLoading' | 'tableRowsContainerClassName' | 'tableTitleClassName' | 'className' | 'hideOnEmpty'
  > {
  realEstatePropertyArray: RealEstate[] | undefined;
  children?: (p: { realEstate: RealEstate }) => React.ReactNode;
}

export const RealEstatePropertyTableContainer = ({
  realEstatePropertyArray,
  children,
  ...props
}: RealEstatePropertyTableContainerProps) => {
  return (
    <AmountTable hideOnEmpty={props.hideOnEmpty ?? true} {...props}>
      {realEstatePropertyArray
        ?.sort((a, b) => a.name.localeCompare(b.name))
        .map((realEstate) => children?.({ realEstate }))}
    </AmountTable>
  );
};
